import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=b124d626&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=b124d626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b124d626",
  null
  
)

export default component.exports